// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Ma_d4","colCheckbox":"styles_colCheckbox__-WApR"};